import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { getPreferredLocale, debugAllCookies } from '../../utils/localeUtils';
import { locales, defaultLocale } from '../../../i18n';

const LocaleDetector = () => {
  const router = useRouter();
  const [hasChecked, setHasChecked] = useState(false);

  useEffect(() => {
    // Only run this check on client-side initial load
    if (hasChecked || typeof window === 'undefined') return;

    const checkAndRedirectLocale = () => {
      // Debug: Show all cookies
      debugAllCookies();
      
      const preferredLocale = getPreferredLocale();
      const currentLocale = router.locale || defaultLocale;
      
      console.log(`Current locale: ${currentLocale}`);
      console.log(`Preferred locale from cookie: ${preferredLocale}`);
      
      // If we have a preferred locale and it's different from current locale
      if (preferredLocale && 
          preferredLocale !== currentLocale && 
          locales.includes(preferredLocale)) {
        
        console.log(`Redirecting to: ${preferredLocale}`);
        // Get the current path without locale prefix
        const currentPath = router.asPath;
        
        // Redirect to the preferred locale
        router.push(currentPath, currentPath, { locale: preferredLocale });
      }
      
      setHasChecked(true);
    };

    // Small delay to ensure router is ready
    const timer = setTimeout(checkAndRedirectLocale, 100);
    
    return () => clearTimeout(timer);
  }, [router, hasChecked]);

  return null; // This component doesn't render anything
};

export default LocaleDetector;
